var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Button, ClickAwayListener, FormControl, FormHelperText, Grid, Input, InputLabel, } from '@material-ui/core';
import { Reply } from '@material-ui/icons';
import useColorPicker from './useColorPicker';
import { SliderPicker } from 'react-color';
import { useTranslation } from 'react-i18next';
import { styles } from './styles';
var ColorPicker = function (_a) {
    var label = _a.label, color = _a.color, handleUpdate = _a.handleUpdate, description = _a.description;
    var t = useTranslation().t;
    var _b = useColorPicker(), _c = _b.state, colors = _c.colors, index = _c.index, value = _c.value, error = _c.error, _d = _b.actions, undoColor = _d.undoColor, redoColor = _d.redoColor, addColor = _d.addColor, updateValue = _d.updateValue;
    var inputRef = useRef(null);
    var _color = colors[index];
    var classes = styles({ color: _color });
    var inputString = label.replace(/\s/g, '_').toLowerCase();
    var isFirst = index === 0;
    var isLast = index === colors.length - 1;
    var inputId = "input-" + label.replace(/\s/g, '_').toLowerCase();
    var _e = useState(false), showPicker = _e[0], setShowPicker = _e[1];
    useEffect(function () {
        if (color) {
            addColor(color);
        }
    }, [color, addColor]);
    var handleColor = function (colorObj) {
        addColor(colorObj.hex);
    };
    var handleSliderAdjust = function (colorObj) {
        handleUpdate(colorObj.hex);
    };
    var handleInput = function (e) {
        var regex = /^#(?:[0-9a-fA-F]{3}){1,2}$/g;
        if (regex.test(e.target.value)) {
            handleUpdate(e.target.value);
        }
        updateValue(e.target.value);
    };
    var handleUndo = function () {
        undoColor();
    };
    var handleRedo = function () {
        redoColor();
    };
    var focusInput = function () {
        if (inputRef && inputRef.current && inputRef.current.focus)
            inputRef.current.focus();
    };
    return (_jsxs(_Fragment, { children: [_jsx(ClickAwayListener, __assign({ onClickAway: function () {
                    setShowPicker(false);
                } }, { children: _jsxs(FormControl, __assign({ fullWidth: true, error: error, className: classes.formControl }, { children: [_jsx(InputLabel, __assign({ disableAnimation: true, shrink: true, htmlFor: inputId, "data-testid": "label-" + inputId }, { children: label }), void 0),
                        _jsx(Input, { id: inputId, value: value, classes: {
                                root: classes.input,
                                error: classes.inputError,
                            }, disableUnderline: true, onChange: handleInput, onFocus: function () { return setShowPicker(true); }, "data-testid": inputId, endAdornment: _jsx("div", { className: classes.inputColor, onClick: focusInput, "data-testid": inputId + "-end-adornment" }, void 0), inputRef: inputRef }, void 0),
                        _jsx("div", __assign({ className: classes.pickerWrapper }, { children: _jsxs("div", __assign({ "data-testid": "picker-container", className: classes.pickerContainer, style: { display: showPicker ? 'block' : 'none' } }, { children: [_jsx("div", __assign({ className: classes.pickerText }, { children: t('label.sampleText') }), void 0),
                                    _jsx(SliderPicker, { color: _color, onChange: handleColor, onChangeComplete: handleSliderAdjust }, void 0)] }), void 0) }), void 0),
                        _jsx(FormHelperText, __assign({ error: false }, { children: description }), void 0)] }), void 0) }), void 0),
            _jsxs(Grid, __assign({ container: true, justify: "space-between", wrap: "nowrap" }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsxs(Button, __assign({ color: "inherit", onClick: handleUndo, disabled: isFirst, "data-testid": inputString + "-undo-button", className: classes.button }, { children: [_jsx(Reply, {}, void 0),
                                _jsx("div", __assign({ className: classes.buttonText }, { children: t('button.undo') }), void 0)] }), void 0) }), void 0),
                    _jsx(Grid, __assign({ item: true }, { children: _jsxs(Button, __assign({ color: "inherit", onClick: handleRedo, disabled: isLast, "data-testid": inputString + "-redo-button", className: classes.button }, { children: [_jsx(Reply, { className: classes.redoIcon }, void 0),
                                _jsx("div", __assign({ className: classes.buttonText }, { children: t('button.redo') }), void 0)] }), void 0) }), void 0)] }), void 0)] }, void 0));
};
export default ColorPicker;
